import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid, Shadow, Transition, Type } from '../../app/StyleGuide';
import { SmallWhiteButton } from '../../components/Buttons';
import { FeedbackCard } from './FeedbackCard';

const Card = styled(FeedbackCard)`
  background-color: ${Color.white};
  border: 2px dashed ${Color.Gray._30};
  box-shadow: none;
  border-radius: ${Border.radius};
  cursor: pointer;
  transition: ${Transition.fast};

  &:hover {
    transform: scale(1.02);
    box-shadow: ${Shadow.medium};
    z-index: 1;
  }
`;

const AvailableSlot = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Grid._4};
  width: 100%;
  min-height: 192px;
  padding: ${Grid._4};

  p {
    margin: 0;
    font-size: ${Type.Scale._2};
    color: ${Type.Color.medium};
    text-align: center;
  }
`;

const AvailableSlotIcon = styled.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${Grid._8};
  height: ${Grid._8};
  border-radius: 50%;
  font-size: ${Type.Scale._4};
  color: ${Color.Gray._70};
  background: ${Color.Gray._10};
  border: 1px solid ${Color.Gray._30};
`;

type EmptyFeedbackCardProps = {
  onClick: () => void;
};

export default function EmptyFeedbackCard({ onClick }: EmptyFeedbackCardProps) {
  return (
    <Card onClick={onClick}>
      <AvailableSlot>
        <AvailableSlotIcon className="fas fa-user-plus" />
        <p>Available slot</p>
        <SmallWhiteButton onClick={onClick}>
          <i className="fas fa-plus" />
          Add Feedback Recipient
        </SmallWhiteButton>
      </AvailableSlot>
    </Card>
  );
}
